import styled from 'styled-components'

export default styled.div`
  .hero {
    &-tag {
      margin-top: 16px;
      display: block;
      color: #4951ea;
      font-family: 'Open Sans';
      font-size: 20px;
      font-weight: bold;
      line-height: 27px;
    }
    &-title {
      color: #333333;
      font-family: 'Poppins', sans-serif;
      font-size: 50px;
      font-weight: bold;
      line-height: 76px;
      margin: 0;
      > span {
        color: #ff7201;
      }
    }
    &-desc {
      color: #555555;
      font-family: 'Open Sans';
      font-size: 18px;
      line-height: 29px;
      width: 95%;
    }
    &-banner {
      position: relative;
      padding-top: 110px;
      @media screen and (min-width: 1440px) {
        padding-top: 130px;
      }
      &--background {
        display: block;
        width: 71%;
        position: absolute;
        top: 0;
        right: 0;
        @media screen and (min-width: 1440px) and (max-width: 1600px) {
          width: 73%;
        }
        @media screen and (min-width: 1600px) and (max-width: 1900px) {
          width: 72%;
        }
      }
      &--people {
        display: block;
        position: absolute;
        top: 213px;
        right: 180px;
        width: 500px;
        right: 170px !important;
        > img {
          width: 100%;
          display: block;
        }
        @media screen and (min-width: 1440px) {
          right: 220px;
        }
      }
    }
  }

  @media screen and (min-width: 300px) and (max-width: 1023px) {
    .hero-banner {
      padding-top: 55px;
    }

    .section-1-tentang-kami {
      width: 100%;
      max-width: 100%;
      flex-basis: unset;
    }

    .hero-banner--background,
    .hero-banner--people {
      display: none;
    }
  }
`
